import type { PrivateVault } from '../../application/models';
import { CountryCode, SectionId } from '../../domain';

const isRecord = (value: unknown): value is Readonly<Record<string, unknown>> =>
  typeof value === 'object' && value !== null;

/** Gives section ids and country codes back their branded form after a JSON round trip. */
export const reviveValueObject = (_key: string, value: unknown): unknown => {
  if (!isRecord(value) || typeof value['value'] !== 'string') {
    return value;
  }
  if (value['brand'] === 'SectionId') {
    return SectionId.create(value['value']);
  }
  if (value['brand'] === 'CountryCode') {
    return CountryCode.create(value['value']);
  }
  return value;
};

export class PrivateVaultCodec {
  private readonly encoder = new TextEncoder();
  private readonly decoder = new TextDecoder('utf-8', { fatal: true });

  encode(vault: PrivateVault): Uint8Array<ArrayBuffer> {
    return this.encoder.encode(JSON.stringify(vault));
  }

  decode(bytes: Uint8Array): PrivateVault {
    const vault: PrivateVault = JSON.parse(this.decoder.decode(bytes), reviveValueObject);
    return vault;
  }
}
